/**
 * DO NOT USE VALUES IN THIS ENUM DIRECTLY. Access them via the `theme` object instead.
 */
enum Colors {
  aqua = '#BFEFF7',
  blueberry = '#5B3F8C',
  bluish = '#2D84CB',
  blueDark = '#1B4F79',
  bridalHeath = '#FFF8F0',
  burnt = '#CC8016',
  danube = '#667ECC',
  grass = '#60A66C',
  leather = '#997C2E',
  plum = '#945499',
  purpleDark = '#532F56',
  lilac = '#E1D8F1',
  whiteLilac = '#F7F9FC',
  redish = '#CC5260',
  salmon = '#CB7252',
  topaz = '#10B2A0',
  water = '#41A3CC',
  earth = '#0DAB5C',
  sun = '#FED325',
  fire = '#E61030',
  amber = '#FBC005',
  chestnutRose = '#CC5260',
  guardsmanRed = '#C80000',
  white = '#FFFFFF',
  feather = '#FBFBFB',
  whisper = '#F7F5F9',
  whisperLight = '#FBFAFC',
  negroni = '#FFE1BF',
  hummingBirdBlue = '#D7F5FA',
  scarpa = '#575766',
  silver = '#D9D9D9',
  coin = '#AAAAAA',
  boulder = '#767676',
  shadow = '#303030',
  black = '#000000',

  sadder = '#2774B3',
  sad = '#359DF2',
  happy = '#7BA660',
  happier = '#97CC76',
  happiest = '#FFC926',

  aqua1 = '#F2FCFD',
  aqua5 = '#5ED7EB',
  aqua6 = '#3ABBCE',
  aqua7 = '#008598',
  aqua8 = '#005365',

  blue1 = '#EBF9FF',
  blue6 = '#009BFF',
  blue7 = '#006AFF',
  blue8 = '#0040FF',

  gray2 = '#F1F0F5',
  gray3 = '#E9E7F0',
  gray4 = '#E3E0F5',
  gray5 = '#C7C4D9',
  gray6 = '#ACA9BD',
  gray7 = '#8E8E9F',
  /**
   * @deprecated
   */
  gray8 = '#575766',
  gray9 = '#1B1A29',

  yellow1 = '#FEFAEB',
  yellow3 = '#FBE699',
  yellow4 = '#FFDB34',
  yellow5 = '#F4C000',

  green1 = '#F1FCF7',
  green6 = '#32C283',
  green7 = '#008B51',
  green8 = '#005723',

  indigo9 = '#000787',

  orange1 = '#FFF6EB',
  orange4 = '#FFA600',
  orange5 = '#FF8900',
  orange8 = '#A70000',
  orange9 = '#FFD099',

  pink1 = '#FFF4FB',
  pink6 = '#FF5BAE',
  pink7 = '#EA007A',
  pink8 = '#AB004A',

  purple1 = '#FDF8FF',
  purple6 = '#CE8BFF',
  purple7 = '#9456E2',
  purple8 = '#5B22A9',
  purple9 = '#1B0074',
  green9 = '#002A00',
  green5 = '#55DE9D',

  red2 = '#FFD6DC',
  red6 = '#FF0037',

  // V2
  almostWhite = '#f7f7f8',
  jumbo = '#747380',
  gunpowder = '#3D3B4D',
  indigo = '#2031BD',
  mint = '#32C283',
  magicMint = '#BBF2D8',
  riverBed = '#4f4e5e',
  suit = '#bebec4',
  cornflower = '#6C61F7',
  buttery = '#FEF9E7',
  mustard = '#B28C00',
  rosso = '#CC000D',
  titanWhite = '#EFEEFF',
  baltic = '#1B1B20',
  porcelain = '#F1F1F2',
  persian = '#000787',

  // DESIGN SYSTEM TOKENS
  yellow500 = '#FFF964',
  yellow600 = '#E3DB29',
  blue500 = '#80B2FF',
  blue600 = '#4484E4',
  blue700 = '#1D60C7',
  cream100 = '#FFF9EF',
  glass100 = 'rgba(13, 3, 0, 0.05)',
  glass200 = '#E7E0D7',
  glass300 = '#CFC8BF',
  glass600 = '#6E6560',
  glass900 = '#180F0C',
  transparent = 'transparent',
}

export default Colors;
